import { Utils } from '@gv/triage-components';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { apiLoaderQuery } from 'store/query';

import { GetFormResponsesRequest, FormResponsesListResponse } from './types';

const tagType = 'FormResponses';

export const formResponsesApi = createApi({
  tagTypes: [tagType],
  baseQuery: apiLoaderQuery,
  reducerPath: 'formResponsesApi',
  endpoints: (build) => ({
    getFormResponses: build.query<
      FormResponsesListResponse,
      GetFormResponsesRequest
    >({
      providesTags: (result, error, { hospitalId }) => [
        { type: tagType, id: hospitalId },
      ],
      transformResponse: (response: any) => {
        return {
          time: response.time,
          data: response.data.data,
          message: response.message,
          success: response.success,
          permission_updated: response.permission_updated,
          totaltime_pages: response.data.data.pagination?.total_pages || 0,
        };
      },
      query: ({
        search,
        page = 1,
        end_date,
        limit = 20,
        hospitalId,
        start_date,
      }) => {
        const searchParams: Record<string, any> = {
          page,
          limit,
          hospital_id: hospitalId,
        };

        if (search) {
          searchParams.case_id = search;
        }

        if (start_date) {
          searchParams.start_date = `${start_date}T00:00:00.000Z`;
        }

        if (end_date) {
          searchParams.end_date = `${end_date}T23:59:59Z`;
        }

        const url = Utils.Query.addParamsToUrl(
          URL.GET_FORM_RESPONSES,
          searchParams
        );

        return {
          url,
          method: 'get',
        };
      },
    }),
  }),
});

export const { useGetFormResponsesQuery, useLazyGetFormResponsesQuery } =
  formResponsesApi;
